import styled, { css } from 'styled-components';

export const Container = styled.header`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    height: 90px;
    padding: 1rem 2rem;
    border-bottom: 1px solid ${theme.palette.neutral[200]};
    transition: 0.3s;
    background: ${theme.palette.neutral[50]};

    > div {
      width: 100%;
      max-width: ${theme.layout.breakpoints.lg};
    }

    @media (max-width: ${theme.layout.breakpoints.md}) {
      padding: 1.5rem 2rem;
    }
  `}
`;
